var Header = function () {

	this.init = function () {
		// open and close mobile-menu on click
		$('[data-component="header"] .menu-icon, .menu-bg').on('click', function () {
			if ($('[data-component="header"]').hasClass('menu-opened')) {
				$('[data-component="header"]').removeClass('menu-opened');
				$('body').removeClass('menu-is-opened')
				closeAllAccordions();

			} else {
				$('[data-component="header"]').addClass('menu-opened');
				$('body').addClass('menu-is-opened')
			}
		})

		// open and close accordion menu on click
		$('.item-menu-btn').on('click', function () {
			if ($(window).innerWidth() < 992) {
				closeAllAccordions()

				if ($(this).next().css('display') == 'block') {
					$(this).next().slideUp(300);
				} else {
					$(this).addClass('accordion-open').next().slideDown(300);
				}
			}
		})

		// open menu with focus on search-bar
		$('.btn-search').on('click', function (event) {
			if ($(window).innerWidth() < 992) {
				if (!$('[data-component="header"]').hasClass('menu-opened')) {
					event.preventDefault();
					$('.menu-icon').trigger('click')
					$('.search').focus();
				}
			}
		})

		// close all accordion-menus
		function closeAllAccordions() {
			$('.item-menu-btn').removeClass('accordion-open');
			$('.submenu').slideUp(300);
		}

		// accessibility control //
		var $textElems = $('h1, h2, h3, h4, h5, h6, p, a, span, strong, em, ul, ol, li, label, input, select, textarea, tr, button');
		var currentSize = 0;

		function changeFont() {
			$textElems.each(function () {
				var $elem = $(this);
				var originalSize = $elem.data('originalFontSize');

				if (originalSize === undefined) {
					var size = parseInt($elem.css('font-size'));
					$elem.data('originalFontSize', size);
					originalSize = size;
				}

				$elem.css('font-size', originalSize + (originalSize * currentSize * 0.1));
			});

			// trigger resize window because of slick height calculation
			$(window).trigger('resize')
		}

		function increaseFont() {
			if (currentSize < 3) {
				changeFont(currentSize++);
			}
		}

		function decreaseFont() {
			if (currentSize >= 1) {
				changeFont(currentSize--);
			}
		}

		function toggleContrast() {
			$('html').toggleClass('contrast');
		}

		$('.increase-font').on('click', increaseFont);
		$('.decrease-font').on('click', decreaseFont);
		$('.toogle-contrast').on('click', toggleContrast);
	}


	return this.init();
}
